import {AGSAutoplayConfigSchema, UiElements} from "gameiom/wrapper/wrapper-data";

class GameiomModel {
    public url: string;
    public sessionToken: string;
    public username: string;
    public providerId: number;
    public operatorId: number;
    public gameId: number;
    public language: string;
    public currency: string;
    public callbackUrl: string;
    public jurisdiction: string;
    public displayCurrency: boolean;
    public enableForcing: boolean;
    public displayMaxBet: boolean;
    public denomDisplay: string;
    public displayClock: boolean;
    public autoplay: AGSAutoplayConfigSchema;
    public disableSpinSkip: boolean;
    public minStopDuration: number;
    public hideJackpotWording: boolean;
    public disableFullscreen: boolean;
    public displayType: string;

    public displayButtons: Map<UiElements, boolean> = new Map<UiElements, boolean>([
        [UiElements.homeButton, true],
        [UiElements.depositPageButton, false],
        [UiElements.accountsButton, false]
    ] as any);
}

export default new GameiomModel();
